const GET_ORG_DEPARTMENTS_REQUEST = 'GET_ORG_DEPARTMENTS_REQUEST';
const GET_ORG_DEPARTMENTS_COMPLETE = 'GET_ORG_DEPARTMENTS_COMPLETE';
const GET_ORG_DEPARTMENTS_ERROR = 'GET_ORG_DEPARTMENTS_ERROR';

const GET_ORG_LIST_REQUEST = 'GET_ORG_LIST_REQUEST';
const GET_ORG_LIST_COMPLETE = 'GET_ORG_LIST_COMPLETE';
const GET_ORG_LIST_ERROR = 'GET_ORG_LIST_ERROR';

export default {
  GET_ORG_DEPARTMENTS_REQUEST,
  GET_ORG_DEPARTMENTS_COMPLETE,
  GET_ORG_DEPARTMENTS_ERROR,

  GET_ORG_LIST_REQUEST,
  GET_ORG_LIST_COMPLETE,
  GET_ORG_LIST_ERROR
}
